export default {
  title: 'Cart',
};
